import { Step as MuiStep, StepProps } from "@mui/material";

type Props = StepProps;

export const Step = ({ children, ...props }: Props) => {
  return <MuiStep {...props}>{children}</MuiStep>;
};
